import { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { ModalAlert } from "../../components/modal";
import { ModalAlertDiv, ReportDiv } from "./style";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { Autocomplete, Button, CircularProgress, Switch, TextField } from "@mui/material";
import { newDateFormat } from "../../components/date";
import Fields from "../../components/fields";
import { api, getFilter, statusApi } from "../../services/axios";
// import Select from '@mui/material/Select';
import axios from "axios";
import SelectMui from "../../components/select";
import { encode } from 'base-64';
import { useContext } from "react";
import AuthContext from "../../services/authContext";
import fileDownload from "js-file-download";

function Reports() {
  const { auth } = useContext(AuthContext)

  const url = "core/ajax/report"

  const dataOriginal = process.env.REACT_APP_REPORT_DATE_FROM;
  const dataSplited = dataOriginal.split('-');
  const dataFormatada = new Intl.DateTimeFormat('pt-BR').format(new Date(dataOriginal + 'T00:00:00'));

  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  
  const ref = useRef(null)

  const [showDate, setShowDate] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState([{ label: '', values: '' }]);
  const [provider, setProvider] = useState([{ label: '', values: '' }]);
  const [camp, setCamp] = useState([{ label: '', values: '' }]);
  const [product, setProduct] = useState([{ label: '', values: '' }]);
  const [transformer, setTransformer] = useState([{ label: '', values: '' }]);
  const [type, setType] = useState([{ label: '', values: '' }]);
  const [tags, setTags] = useState([]);


  const [msg, setMsg] = useState({})
  const [isEspecific, setIsEspecific] = useState(false)

  const base64ToCsvBlob = (base64) => {
    const binaryString = atob(base64)
    const bytes = new Uint8Array(binaryString.length)

    for (let index = 0; index < binaryString.length; index += 1) {
      bytes[index] = binaryString.charCodeAt(index)
    }

    return new Blob([bytes], { type: 'text/csv;charset=utf-8;' })
  }

  const specificFilter = {
    filterOperator: [{ label: '=', value: 'equals' },
    { label: 'CONTAINS', value: 'contains' },
    { label: 'IN LIST', value: 'inList' }],
    filterField: filterFieldDefault,
  }

  const [filters, setFilters] = useState({
    name: '',
    provider: [''],
    camp: [''],
    product: [''],
    transformer: [''],
    type: [''],
    filterOperator: '',
    filterField: '',
    filterValue: '',
  });

  useEffect(() => {
    console.log("Reports component mounted, loading filters...");
    getFilter('', 'storeTree', setName)
    getFilter('', 'comboFilterProvider', setProvider)
    getFilter('', 'comboFilterCamp', setCamp)
    getFilter('', 'comboFilterProduct', setProduct)
    getFilter('', 'comboFilterTransformer', setTransformer)
    getFilter('', 'comboFilterType', setType)

    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setShowDate(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const createFile = async e => {
    setShowModal(true)
    setMsg({})
    let fields = localStorage.getItem('fields').split(",")

    const info = {
      generatorConversion: filters.provider,
      productConversion: filters.product,
      converterConversion: filters.transformer,
      typeConversion: filters.type,
      fieldConversion: fields,
    }
    const infoJson = JSON.stringify(info);

    statusApi.get("status").then(function (res) {
      const arr = res.data.split("|")
      arr[0] === 'OK' ?
        api.post("core/ajax/reports.csv", {
          authx: '',
          type: 'getCsvCustom',
          startDate: newDateFormat(range[0].startDate),
          endDate: newDateFormat(range[0].endDate),
          info: infoJson,
          idReport: filters.name ? filters.name : '20',
          filterOperator: filters.filterOperator,
          filterField: filters.filterField[1],
          filterValue: tags.length > 0 ? tags.toString() : filters.filterValue,
        })
          .then(function (response) {
            const base64 = response.data.csv
            const fileName = response.data.filename || 'report.csv'
            const blob = base64ToCsvBlob(base64)
            const blobUrl = URL.createObjectURL(blob)
            const aTag = document.createElement("a")
            aTag.href = blobUrl
            aTag.setAttribute("download", fileName)
            document.body.appendChild(aTag)
            aTag.click()
            aTag.remove()
            URL.revokeObjectURL(blobUrl)
            setMsg(response.data);
          })
          .catch(function (error) {
            console.log(error);
          }) : window.location.reload(false);

    }).catch(function (error) {
      console.log(error);
    });


  };

  return (
    <ReportDiv>
      <div className="title">
        <h1>
          Reports <span>(a partir de {dataFormatada})</span>
        </h1>
      </div>
      <div className="filters">

        <SelectMui
          values={name}
          state={filters.name}
          width={'250px'}
          size={'small'}
          label={'TYPE REPORT'}
          onChange={(e) => {
            setFilters({
              ...filters,
              name: e.target.value
            })
          }}
        />
        <div className={"date"} >
          <div className="date-inp">
            <input
              type="text"
              value={`${newDateFormat(range[0].startDate)}   ${newDateFormat(range[0].endDate)}`}
              readOnly="readonly"
              onClick={() => {
                setShowModal(false)
                setShowDate(!showDate)
              }
              }
              className={"date-inp"}
            />
            <CalendarMonthOutlinedIcon className="icon" />
          </div>
          {showDate && (
            <div
              ref={ref}>
              <DateRangePicker
                ranges={range}
                onChange={(item) => {
                  setRange([item.selection])
                }}
                minDate={new Date(dataSplited[0], dataSplited[1] - 1, dataSplited[2])}
                dateDisplayFormat='yyyy-MM-dd'
                editableDateInputs={true}
                months={2}
                direction={"horizontal"}
                className={"date-picker"}
              />
            </div>
          )}
        </div>


        <Autocomplete
          multiple
          autoSelect
          style={{ width: '250px' }}
          size='small'
          options={provider}
          onChange={(e, value) => {
            setFilters({ ...filters, provider: value.map(a => a.value) })
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="GENERATOR"
              placeholder="GENERATOR"
              value={filters.provider}
            />
          )}
        />


        <Autocomplete
          multiple
          autoSelect
          style={{ width: '250px' }}
          size='small'
          options={camp}
          onChange={(e, value) => {
            setFilters({ ...filters, camp: value.map(a => a.value) })
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="CAMPAIGN"
              placeholder="CAMPAIGN"
              value={filters.camp}
            />
          )}
        />

        <Autocomplete
          multiple
          autoSelect
          style={{ width: '250px' }}
          size='small'
          options={product}
          onChange={(e, value) => {
            setFilters({ ...filters, product: value.map(a => a.value) })
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="PRODUCT"
              placeholder="PRODUCT"
              value={filters.product}
            />
          )}
        />

        <Autocomplete
          multiple
          autoSelect
          style={{ width: '250px' }}
          size='small'
          options={transformer}
          onChange={(e, value) => {
            setFilters({ ...filters, transformer: value.map(a => a.value) })
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="CONVERTER"
              placeholder="CONVERTER"
              value={filters.transformer}
            />
          )}
        />

        <Autocomplete
          multiple
          autoSelect
          style={{ width: '250px' }}
          size='small'
          options={type}
          onChange={(e, value) => {
            setFilters({ ...filters, type: value.map(a => a.value) })
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="TYPE"
              placeholder="TYPE"
              value={filters.type}
            />
          )}
        />
        <Fields />
      </div>

      <div className="switch">
        <h1>Especific Filter</h1>
        <Switch checked={isEspecific} onChange={() => {
          setFilters({
            ...filters,
            filterField: '',
            filterOperator: '',
            filterValue: '',
          })
          setIsEspecific(!isEspecific)
        }} />
      </div>
      <div className="filters">

        <Autocomplete
          size='small'
          className={'type'}
          defaultValue=""
          autoSelect
          clearOnEscape
          disabled={!isEspecific}
          options={filterFieldDefault}
          getOptionLabel={(option) => option[0] || ""}
          isOptionEqualToValue={(option, value) => {
            return option[0] === value[0] || option[0] === ''
          }}
          value={filters.filterField}
          onChange={(event, value) => {
            console.log(filters.filterField);
            value !== null ?
              setFilters({
                ...filters,
                filterField: value
              }) : setFilters({
                ...filters,
                filterField: ''
              })

          }}
          renderInput={(params) => <TextField {...params}
            label="FIELD" />}
        />

        <SelectMui
          label={'OPERATOR'}
          size={'small'}
          width={'250px'}
          values={specificFilter.filterOperator}
          disabled={!isEspecific}
          state={filters.filterOperator !== null ? filters.filterOperator : ''}
          helpText={filters.filterOperator === 'inList' ? '* if the value is any of the list' : (filters.filterOperator === 'contains' ? '* If the value is contained in the text' : '')}
          onChange={(e) => {
            if (e.target.value !== 'inList') {
              setFilters({
                ...filters,
                filterValue: null
              })
              setTags([])
            }
            setFilters({
              ...filters,
              filterOperator: e.target.value
            })
          }}
        />

        {filters.filterOperator === 'inList' ?
          <Autocomplete
            multiple
            freeSolo
            size='small'
            value={tags}
            disabled={(filters.filterOperator === '' || filters.filterOperator === null) ? true : false}
            style={{ width: '250px' }}
            id="tags-outlined"
            limitTags={2}
            options={tags}
            getOptionLabel={(option) => option || ""}

            onChange={(e, val) => {
              e.target?.value?.trim() !== '' && setTags(val.map(e => e?.trim()))
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="VALUES"
                placeholder="VALUES"
                helperText={'* Press enter to add values'}
              />
            )}
          /> :
          <TextField
            disabled={(filters.filterOperator === '' || filters.filterOperator === null) ? true : false}
            margin="none"
            variant="outlined"
            value={filters.filterValue}
            size="small"
            sx={{ width: '250px' }}
            label={'VALUE'}
            onChange={e => {
              setFilters({
                ...filters,
                filterValue: e.target.value
              });
            }} />
        }


      </div>
      <Button variant="contained" className={"btn-report"} onClick={() => createFile()} >Download</Button>
      <ModalAlert showModal={showModal} onClose={(e, r) => {
        (r !== 'backdropClick' | msg.response) && setShowModal(!showModal)
      }} >
        {msg.response === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Downloading...</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : msg.response ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>
              <Button onClick={() => {
                setShowModal(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h1>{msg.title}</h1>
              <h3>:&#40;	</h3>
              <h3>{msg.text}</h3>
            </ModalAlertDiv>}

      </ModalAlert>
      {/* <ModalAlert showModal={showModal} setShowModal={setShowModal} onClickOutside={false}>
        {msg.response === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Downloading...</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : msg.response ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h1>{msg.title}</h1>
              <h3>:&#40;	</h3>
              <h3>{msg.text}</h3>
            </ModalAlertDiv>}
      </ModalAlert> */}
    </ReportDiv >
  );
}

export default Reports;

// const filterFieldDefault2 = [
//   'WsIdAsb',
//   'WsTs',
//   'WsDate',
//   'WsProvider',
//   'WsCountryCode',
//   'WsPhone',
//   'WsName',
//   'WsSurname',
//   'WsNomeUsuario',
//   'WsEmail',
//   'WsDnis',
//   'WsIp',
//   'WsUrl',
//   'WsProduct',
//   'WsOffer',
//   'WsDateScheduled',
//   'WsTimeScheduled',
//   'WsIdExt',
//   'WsId_session',
//   'WsSource',
//   'WsMedia',
//   'WsCampanha',
//   'WsContent',
//   'WsCanal',
//   'WsTerm',
//   'WsAdn',
//   'WsUtm_origem',
//   'WsCnpj',
//   'WsCpf',
//   'WsRg',
//   'WsOrgaoExpedidor',
//   'WsNomeMae',
//   'WsObservacoes',
//   'WsSexo',
//   'WsDataNascimento',
//   'WsSegmento',
//   'WsGastoMensal',
//   'WsMensagem',
//   'WsTecnologia',
//   'WsStatus',
//   'WsFollowUp',
//   'WsCodPedido',
//   'WsDataPedido',
//   'WsHoraPedido',
//   'WsPacoteTv',
//   'WsPacoteInternet',
//   'WsPacoteTelefone',
//   'WsItensAdicionais',
//   'WsTermosCondicoes',
//   'WsOrigem',
//   'WsDataAgendamentoEquipamento',
//   'WsPeriodoAgendamentoEquipamento',
//   'WsFormaPagamento',
//   'WsDataVencimentoConta',
//   'WsPedido_anterior',
//   'WsQuantidadeLinhas',
//   'WsEntrega',
//   'WsNumero',
//   'WsCep',
//   'WsBairro',
//   'WsCidade',
//   'WsUf',
//   'WsComplemento',
//   'WsTipoImovel',
//   'WsEntregaTipo',
//   'WsEntregaPontoReferencia',
//   'WsDddTelefone2',
//   'WsNumTelefone2',
//   'WsDddTelefone3',
//   'WsNumTelefone3',
//   'WsTelPreferencial',
//   'WsHorarioPreferencial',
//   'WsOptIn',
//   'WsExtra1',
//   'WsExtra2',
//   'WsExtra3',
//   'WsExtra4',
//   'WsExtra5',
//   'WsExtra6',
//   'WsExtra7',
//   'WsExtra8',
//   'WsExtra9',
//   'WsExtra10',
//   'WsExtra11',
//   'WsExtra12',
//   'WsExtra13',
//   'WsExtra14',
//   'WsExtra15',
//   'CampId',
//   'CampName',
//   'CampChannel',
//   'CampProduct',
//   'CampChannel',
//   'ResDestination',
//   'ResTsProcessed',
//   'ResTransformers',
//   'WsBrowserDevice',
//   'WsBrowser',
//   'WsBrowserOs',
//   'WsBrowserLan',
//   'WsGeoIp',
//   'WsFaturaDigital',
//   'WsNumeroInscricaoEstadual',
//   'WsEstadoInscricaoEstadual',
//   'WsGclid',
//   'WsTipoIp',
//   'WsEnderecoCobranca',
//   'WsLeadAmbiente',
//   'WsLeadDevice',
//   'WsVersaoTeste',
//   'WsPagEntrada',
//   'WsPagReferencia',
//   'WsCtaSaida',
//   'WsCidadeBussola',
//   'WsEstadoBussola',
//   'WsIdPID',
//   'WsFidelizado',
//   'WsPacoteMovel',
//   'WsPacoteCloud',
//   'WsBanco',
//   'WsAgencia',
//   'WsConta',
//   'WsUfOrgaoExpedidor',
//   'WsPortabilidade',
//   'WsNumPortabilidade',
//   'WsDataAgendamentoEquipamento2',
//   'WsDataAgendamentoEquipamento3',
//   'WsPeriodoAgendamentoEquipamento2',
//   'WsPeriodoAgendamentoEquipamento3']

/*
  ['WsProvider', 'WCPAN.Company'],
  ['CampName', 'WC.Campaign'],
  ['CampChannel', 'WCCv2.Channel'],
  ['CampProduct', 'WCP1.Product'],
  ['CampUri', 'WC.Uri'],
  ['ResTransformers', 'WSTA.Result'],
*/

const filterFieldDefault = [
  ['WsType', 'Type'],
  ['WsSubType', 'SubType'],
  ['WsIdAsb', 'IdWs'],
  ['WsTs', 'Ts'],
  ['WsDate', 'Date'],
  ['WsProvider', 'Company'],
  ['WsCountryCode', 'CountryCode'],
  ['WsPhone', 'Phone'],
  ['WsName', 'Name'],
  ['WsSurname', 'Surname'],
  ['WsNomeUsuario', 'nomeUsuario'],
  ['WsEmail', 'Mail'],
  ['WsDnis', 'Dnis'],
  ['WsIp', 'IpClient'],
  ['WsUrl', 'Url'],
  ['WsProduct', 'Product'],
  ['WsOffer', 'Offer'],
  ['WsDateScheduled', 'DateScheduled'],
  ['WsTimeScheduled', 'TimeScheduled'],
  ['WsIdExt', 'IdExt'],
  ['WsId_session', 'id_session'],
  ['WsSource', 'source'],
  ['WsMedia', 'media'],
  ['WsCampanha', 'campanha'],
  ['WsContent', 'content'],
  ['WsCanal', 'canal'],
  ['WsTerm', 'term'],
  ['WsAdn', 'adn'],
  ['WsUtm_origem', 'utm_origem'],
  ['WsCnpj', 'cnpj'],
  ['WsCpf', 'cpf'],
  ['WsRg', 'rg'],
  ['WsOrgaoExpedidor', 'orgaoExpedidor'],
  ['WsNomeMae', 'nomeMae'],
  ['WsObservacoes', 'observacoes'],
  ['WsSexo', 'sexo'],
  ['WsDataNascimento', 'dataNascimento'],
  ['WsSegmento', 'segmento'],
  ['WsGastoMensal', 'gastoMensal'],
  ['WsMensagem', 'mensagem'],
  ['WsTecnologia', 'tecnologia'],
  ['WsStatus', 'status'],
  ['WsFollowUp', 'followUp'],
  ['WsCodPedido', 'codPedido'],
  ['WsDataPedido', 'dataPedido'],
  ['WsHoraPedido', 'horaPedido'],
  ['WsPacoteTv', 'pacoteTv'],
  ['WsPacoteInternet', 'pacoteInternet'],
  ['WsPacoteTelefone', 'pacoteTelefone'],
  ['WsItensAdicionais', 'itensAdicionais'],
  ['WsTermosCondicoes', 'termosCondicoes'],
  ['WsOrigem', 'Origem'],
  ['WsDataAgendamentoEquipamento', 'dataAgendamentoEquipamento'],
  ['WsPeriodoAgendamentoEquipamento', 'periodoAgendamentoEquipamento'],
  ['WsFormaPagamento', 'formaPagamento'],
  ['WsDataVencimentoConta', 'dataVencimentoConta'],
  ['WsPedido_anterior', 'pedido_anterior'],
  ['WsQuantidadeLinhas', 'quantidadeLinhas'],
  ['WsEntrega', 'Entrega'],
  ['WsNumero', 'Numero'],
  ['WsCep', 'Cep'],
  ['WsBairro', 'Bairro'],
  ['WsCidade', 'Cidade'],
  ['WsUf', 'UF'],
  ['WsComplemento', 'Complemento'],
  ['WsTipoImovel', 'tipoImovel'],
  ['WsEntregaTipo', 'EntregaTipo'],
  ['WsEntregaPontoReferencia', 'EntregaPontoReferencia'],
  ['WsDddTelefone2', 'dddTelefone2'],
  ['WsNumTelefone2', 'numTelefone2'],
  ['WsDddTelefone3', 'dddTelefone3'],
  ['WsNumTelefone3', 'numTelefone3'],
  ['WsTelPreferencial', 'telPreferencial'],
  ['WsHorarioPreferencial', 'horarioPreferencial'],
  ['WsOptIn', 'optIn'],
  ['WsExtra1', 'EXTRA1'],
  ['WsExtra2', 'EXTRA2'],
  ['WsExtra3', 'EXTRA3'],
  ['WsExtra4', 'EXTRA4'],
  ['WsExtra5', 'EXTRA5'],
  ['WsExtra6', 'EXTRA6'],
  ['WsExtra7', 'EXTRA7'],
  ['WsExtra8', 'EXTRA8'],
  ['WsExtra9', 'EXTRA9'],
  ['WsExtra10', 'EXTRA10'],
  ['WsExtra11', 'EXTRA11'],
  ['WsExtra12', 'EXTRA12'],
  ['WsExtra13', 'EXTRA13'],
  ['WsExtra14', 'EXTRA14'],
  ['WsExtra15', 'EXTRA15'],
  ['CampId', 'IdCamp'],
  ['CampName', 'Campaign'],
  ['CampChannel', 'Channel'],
  ['CampProduct', 'Product'],
  ['CampUri', 'Uri'],
  ['ResDestination', 'ProcessedDestination'],
  ['ResTsProcessed', 'Processed'],
  ['ResTransformers', 'Result'],
  ['WsBrowserDevice', 'browserDevice'],
  ['WsBrowser', 'browser'],
  ['WsBrowserOs', 'browserOs'],
  ['WsBrowserLan', 'browserLan'],
  ['WsGeoIp', 'geoIp'],
  ['WsFaturaDigital', 'faturaDigital'],
  ['WsNumeroInscricaoEstadual', 'numeroInscricaoEstadual'],
  ['WsEstadoInscricaoEstadual', 'estadoInscricaoEstadual'],
  ['WsGclid', 'gclid'],
  ['WsTipoIp', 'tipoIp'],
  ['WsEnderecoCobranca', 'enderecoCobranca'],
  ['WsLeadAmbiente', 'leadAmbiente'],
  ['WsLeadDevice', 'leadDevice'],
  ['WsVersaoTeste', 'versaoTeste'],
  ['WsPagEntrada', 'pagEntrada'],
  ['WsPagReferencia', 'pagReferncia'],
  ['WsCtaSaida', 'ctaSaida'],
  ['WsCidadeBussola', 'cidadeBussola'],
  ['WsEstadoBussola', 'estadoBussola'],
  ['WsIdPID', 'idPID'],
  ['WsFidelizado', 'fidelizado'],
  ['WsPacoteMovel', 'pacoteMovel'],
  ['WsPacoteCloud', 'pacoteCloud'],
  ['WsBanco', 'banco'],
  ['WsAgencia', 'agencia'],
  ['WsConta', 'conta'],
  ['WsUfOrgaoExpedidor', 'UfOrgaoExpedidor'],
  ['WsPortabilidade', 'Portabilidade'],
  ['WsNumPortabilidade', 'NumPortabilidade'],
  ['WsDataAgendamentoEquipamento2', 'DataAgendamentoEquipamento2'],
  ['WsDataAgendamentoEquipamento3', 'DataAgendamentoEquipamento3'],
  ['WsPeriodoAgendamentoEquipamento2', 'PeriodoAgendamentoEquipamento2'],
  ['WsPeriodoAgendamentoEquipamento3', 'PeriodoAgendamentoEquipamento3']
]